import {SortConfig} from 'common/report/util/insights/types';

export const SORT_ICONS = {
  label: `alpha`,
  value: `value`,
};

export const SORT_LABEL_MAPS = {
  label: {
    asc: `Alpha A \u2192 Z`,
    desc: `Alpha Z \u2192 A`,
  },
  value: {
    asc: `Value 1 \u2192 100`,
    desc: `Value 100 \u2192 1`,
  },
};

export interface SortChangeDetail {
  sortBy: keyof typeof SORT_ICONS;
  sortConfig: SortConfig;
}
